import { useMemo, type FC } from 'react';

import { generateHTMLArticleContent } from '@xing-com/crate-articles-article-editor';
import {
  ReadMore,
  EditButton,
  useEntityPageNwtEditViewAction,
  EP_NwtEditViewAction,
} from '@xing-com/crate-entity-pages-common';
import { trackAboutusDescriptionReadMoreAction } from '@xing-com/crate-entity-pages-common/src/tracking';
import { useEditContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import * as Styled from './detailed-description.styles';

type Props = {
  articleHeadline: string;
  articleContent: string;
};
export const DetailedDescription: FC<Props> = ({
  articleHeadline,
  articleContent,
}) => {
  const { trackEntityPageEditView } = useEntityPageNwtEditViewAction();
  const { isEditing } = useEditContext();
  const { pageContext } = usePageContext();

  const htmlContent = useMemo(
    () => generateHTMLArticleContent(articleContent),
    [articleContent]
  );

  const handleOnClickEditButton = () => {
    trackEntityPageEditView(EP_NwtEditViewAction.ABOUT_DESCRIPTION_OPEN);
  };

  return (
    <Styled.ViewerContainer>
      <Styled.HeaderText
        fontWeight="bold"
        lineHeight="dense"
        size="xlarge"
        noMargin
      >
        {articleHeadline}
        {isEditing ? (
          <EditButton
            size="small"
            showIcon={true}
            to={`${pageContext.basePath}/${pageContext.pageSlug}/edit/aboutUsDescription?type=detailed`}
            data-testid="edit-description"
            onClick={handleOnClickEditButton}
          />
        ) : null}
      </Styled.HeaderText>
      <ReadMore
        maxHeight={330}
        trackingAction={() => trackAboutusDescriptionReadMoreAction()}
      >
        <Styled.EditorContent
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </ReadMore>
    </Styled.ViewerContainer>
  );
};
